import React from 'react';

export const ShutterLeftOpeningPostCenterOpeningPostCenterOpening = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 165.32 59.29"
      width="173"
      {...props}
    >
      <g data-name="Group 83-2">
        <g data-name="Group 483">
          <path
            data-name="Rectangle 166"
            fill="#fff"
            d="M5.49.59h154.33v50.8H5.49z"
          />
          <path
            data-name="Path 2322"
            d="M4.72 51.39V.6a.69.69 0 01.77-.6h154.34a.69.69 0 01.77.59v50.8c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zm154.33-50.2H6.26V50.8h152.79z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 484">
          <path
            data-name="Rectangle 167"
            fill="#fff"
            d="M5.49.59h154.33v50.8H5.49z"
          />
          <path
            data-name="Path 2323"
            d="M4.72 51.39V.6a.69.69 0 01.77-.6h154.34a.69.69 0 01.77.59v50.8c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zm154.33-50.2H6.26V50.8h152.79z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 485" fill="#dcd9d5">
          <path data-name="Rectangle 168" d="M9.9 3.94h145.52v44.1H9.9z" />
          <path
            data-name="Path 2324"
            d="M9.89 48.62c-.42 0-.77-.26-.76-.57V4c0-.32.34-.58.77-.58h145.52c.42 0 .77.26.77.58v44c0 .31-.35.57-.77.57H9.89zM154.65 4.54h-144v42.92h144z"
          />
        </g>
        <path
          data-name="Path 2325"
          d="M.73 51.94h163.86c.4 0 .73-.25.73-.55a.67.67 0 00-.73-.56H.73a.67.67 0 00-.73.56c0 .3.33.55.73.55z"
          fill="#dcd9d5"
        />
      </g>
      <g data-name="Group 85">
        <g data-name="Group 498">
          <path
            data-name="Rectangle 182"
            fill="#233762"
            d="M34.54 8.27L6.75 2.24v49.49l27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338"
            d="M6.26 1.53L35 7.76v51.53l-28.78-7zM34 8.8L7.24 3v48.23L34 57.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499">
          <path
            data-name="Rectangle 183"
            fill="#233762"
            d="M31.54 12.93L9.49 8.08v3.57l22.05 4.89v-3.61z"
          />
          <path
            data-name="Path 2339"
            d="M9.24 7.72l22.55 5V17L9.24 12zm22 5.49L9.75 8.47v2.92l21.52 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500">
          <path
            data-name="Rectangle 184"
            fill="#233762"
            d="M31.54 16.54L9.49 11.65v3.57l22.05 4.93v-3.61z"
          />
          <path
            data-name="Path 2340"
            d="M9.24 11.28l22.55 5v4.27L9.24 15.49zm22 5.54L9.75 12v3l21.52 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501">
          <path
            data-name="Rectangle 185"
            fill="#233762"
            d="M31.54 20.15L9.49 15.22v3.57l22.05 4.97v-3.61z"
          />
          <path
            data-name="Path 2341"
            d="M9.24 14.85l22.55 5v4.27L9.24 19.06zm22 5.58L9.75 15.61v2.92l21.52 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502">
          <path
            data-name="Rectangle 186"
            fill="#233762"
            d="M31.54 23.79L9.49 18.81v3.57l22.05 5.02v-3.61z"
          />
          <path
            data-name="Path 2342"
            d="M9.24 18.44l22.55 5.09v4.27L9.24 22.65zm22 5.63L9.75 19.2v2.92L31.27 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503">
          <path
            data-name="Rectangle 187"
            fill="#233762"
            d="M31.54 27.4L9.49 22.38v3.57l22.05 5.06V27.4z"
          />
          <path
            data-name="Path 2343"
            d="M9.24 22l22.55 5.13v4.27L9.24 26.22zm22 5.67l-21.49-4.9v2.92l21.52 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504">
          <path
            data-name="Rectangle 188"
            fill="#233762"
            d="M31.54 31.01L9.49 25.95v3.56l22.05 5.11v-3.61z"
          />
          <path
            data-name="Path 2344"
            d="M9.24 25.57l22.55 5.18V35L9.24 29.79zm22 5.72l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505">
          <path
            data-name="Rectangle 189"
            fill="#233762"
            d="M31.54 34.62L9.49 29.51v3.57l22.05 5.15v-3.61z"
          />
          <path
            data-name="Path 2345"
            d="M9.24 29.14l22.55 5.23v4.26L9.24 33.35zm22 5.76l-21.52-5v2.93l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506">
          <path
            data-name="Rectangle 190"
            fill="#233762"
            d="M31.54 38.23L9.49 33.08v3.57l22.05 5.2v-3.62z"
          />
          <path
            data-name="Path 2346"
            d="M9.24 32.71L31.79 38v4.27L9.24 36.92zm22 5.8l-21.52-5v2.92l21.52 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507">
          <path
            data-name="Rectangle 191"
            fill="#233762"
            d="M31.54 41.85l-22.05-5.2v3.56l22.05 5.25v-3.61z"
          />
          <path
            data-name="Path 2347"
            d="M9.24 36.28l22.55 5.31v4.27L9.24 40.49zm22 5.84L9.75 37v3l21.52 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508">
          <path
            data-name="Rectangle 192"
            fill="#233762"
            d="M31.54 45.48L9.49 40.24v3.57l22.05 5.29v-3.62z"
          />
          <path
            data-name="Path 2348"
            d="M9.24 39.87l22.55 5.36v4.26L9.24 44.08zm22 5.89L9.75 40.63v2.92l21.52 5.16z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509">
          <path
            data-name="Rectangle 193"
            fill="#233762"
            d="M31.54 49.1L9.49 43.81v3.57l22.05 5.33V49.1z"
          />
          <path
            data-name="Path 2349"
            d="M9.24 43.43l22.55 5.4v4.27L9.24 47.65zm22 5.93L9.75 44.2v2.92l21.52 5.2z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194"
          fill="#fff"
          d="M21.07 10.63l-1.44-.32v39.52l1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-2">
        <g data-name="Group 498-2">
          <path
            data-name="Rectangle 182-2"
            fill="#233762"
            d="M66.23 8.27L38.44 2.24v49.49l27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338-2"
            d="M38 1.53l28.73 6.23v51.53L38 52.24zM65.73 8.8L38.93 3v48.23l26.8 6.55z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-2">
          <path
            data-name="Rectangle 183-2"
            fill="#233762"
            d="M63.23 12.93L41.19 8.08v3.57l22.04 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-2"
            d="M40.93 7.72l22.56 5V17l-22.56-5zM63 13.21L41.44 8.47v2.92L63 16.16z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-2">
          <path
            data-name="Rectangle 184-2"
            fill="#233762"
            d="M63.23 16.54l-22.04-4.89v3.57l22.04 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-2"
            d="M40.93 11.28l22.56 5v4.27l-22.56-5.06zm22 5.54L41.44 12v3L63 19.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-2">
          <path
            data-name="Rectangle 185-2"
            fill="#233762"
            d="M63.23 20.15l-22.04-4.93v3.57l22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-2"
            d="M40.93 14.85l22.56 5v4.27L40.93 19zm22 5.58l-21.49-4.82v2.92L63 23.39z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-2">
          <path
            data-name="Rectangle 186-2"
            fill="#233762"
            d="M63.23 23.79l-22.04-4.98v3.57l22.04 5.02v-3.61z"
          />
          <path
            data-name="Path 2342-2"
            d="M40.93 18.44l22.56 5.09v4.27l-22.56-5.15zm22 5.63L41.44 19.2v2.92L63 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-2">
          <path
            data-name="Rectangle 187-2"
            fill="#233762"
            d="M63.23 27.4l-22.04-5.02v3.57l22.04 5.06V27.4z"
          />
          <path
            data-name="Path 2343-2"
            d="M40.93 22l22.56 5.13v4.27l-22.56-5.18zm22 5.67l-21.49-4.9v2.92L63 30.63z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-2">
          <path
            data-name="Rectangle 188-2"
            fill="#233762"
            d="M63.23 31.01l-22.04-5.06v3.56l22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-2"
            d="M40.93 25.57l22.56 5.18V35l-22.56-5.21zm22 5.72l-21.53-5v2.92l21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-2">
          <path
            data-name="Rectangle 189-2"
            fill="#233762"
            d="M63.23 34.62l-22.04-5.11v3.57l22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-2"
            d="M40.93 29.14l22.56 5.23v4.26l-22.56-5.28zm22 5.76l-21.53-5v2.93l21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-2">
          <path
            data-name="Rectangle 190-2"
            fill="#233762"
            d="M63.23 38.23l-22.04-5.15v3.57l22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-2"
            d="M40.93 32.71L63.49 38v4.27l-22.56-5.35zm22 5.8l-21.53-5v2.92l21.6 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-2">
          <path
            data-name="Rectangle 191-2"
            fill="#233762"
            d="M63.23 41.85l-22.04-5.2v3.56l22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-2"
            d="M40.93 36.28l22.56 5.31v4.27l-22.56-5.37zm22 5.84L41.44 37v3L63 45.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-2">
          <path
            data-name="Rectangle 192-2"
            fill="#233762"
            d="M63.23 45.48l-22.04-5.24v3.57l22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-2"
            d="M40.93 39.87l22.56 5.36v4.26l-22.56-5.41zm22 5.89l-21.49-5.13v2.92L63 48.71z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-2">
          <path
            data-name="Rectangle 193-2"
            fill="#233762"
            d="M63.23 49.1l-22.04-5.29v3.57l22.04 5.33V49.1z"
          />
          <path
            data-name="Path 2349-2"
            d="M40.93 43.43l22.56 5.4v4.27l-22.56-5.45zm22 5.93L41.44 44.2v2.92L63 52.32z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-2"
          fill="#fff"
          d="M52.76 10.63l-1.44-.32v39.52l1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-3">
        <g data-name="Group 498-3">
          <path
            data-name="Rectangle 182-3"
            fill="#233762"
            d="M69.64 8.27l27.79-6.03v49.49l-27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338-3"
            d="M97.92 52.24l-28.78 7V7.76l28.78-6.23zm-27.77 5.54L97 51.23V3L70.15 8.8z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-3">
          <path
            data-name="Rectangle 183-3"
            fill="#233762"
            d="M72.65 12.93l22.04-4.85v3.57l-22.04 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-3"
            d="M94.94 11.93l-22.55 5v-4.26l22.55-4.95zm-22 4.23l21.52-4.77V8.47l-21.55 4.74z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-3">
          <path
            data-name="Rectangle 184-3"
            fill="#233762"
            d="M72.65 16.54l22.04-4.89v3.57l-22.04 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-3"
            d="M94.94 15.49l-22.55 5.06v-4.27l22.55-5zm-22 4.28L94.43 15v-3l-21.52 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-3">
          <path
            data-name="Rectangle 185-3"
            fill="#233762"
            d="M72.65 20.15l22.04-4.93v3.57l-22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-3"
            d="M94.94 19.06l-22.55 5.1v-4.27l22.55-5zm-22 4.33l21.52-4.86v-2.92l-21.55 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-3">
          <path
            data-name="Rectangle 186-3"
            fill="#233762"
            d="M72.65 23.79l22.04-4.98v3.57L72.65 27.4v-3.61z"
          />
          <path
            data-name="Path 2342-3"
            d="M94.94 22.65L72.39 27.8v-4.27l22.55-5.09zM72.91 27l21.52-4.9v-2.9l-21.52 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-3">
          <path
            data-name="Rectangle 187-3"
            fill="#233762"
            d="M72.65 27.4l22.04-5.02v3.57l-22.04 5.06V27.4z"
          />
          <path
            data-name="Path 2343-3"
            d="M94.94 26.22l-22.55 5.19v-4.27L94.94 22zm-22 4.41l21.52-4.94v-2.92l-21.55 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-3">
          <path
            data-name="Rectangle 188-3"
            fill="#233762"
            d="M72.65 31.01l22.04-5.06v3.56l-22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-3"
            d="M94.94 29.79L72.39 35v-4.25l22.55-5.18zm-22 4.46l21.52-5v-2.91l-21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-3">
          <path
            data-name="Rectangle 189-3"
            fill="#233762"
            d="M72.65 34.62l22.04-5.11v3.57l-22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-3"
            d="M94.94 33.35l-22.55 5.28v-4.26l22.55-5.23zm-22 4.51l21.52-5v-3l-21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-3">
          <path
            data-name="Rectangle 190-3"
            fill="#233762"
            d="M72.65 38.23l22.04-5.15v3.57l-22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-3"
            d="M94.94 36.92l-22.55 5.33V38l22.55-5.3zm-22 4.55l21.52-5.08v-2.92l-21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-3">
          <path
            data-name="Rectangle 191-3"
            fill="#233762"
            d="M72.65 41.85l22.04-5.2v3.56l-22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-3"
            d="M94.94 40.49l-22.55 5.37v-4.27l22.55-5.31zm-22 4.59L94.43 40v-3l-21.52 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-3">
          <path
            data-name="Rectangle 192-3"
            fill="#233762"
            d="M72.65 45.48l22.04-5.24v3.57L72.65 49.1v-3.62z"
          />
          <path
            data-name="Path 2348-3"
            d="M94.94 44.08l-22.55 5.41v-4.26l22.55-5.36zm-22 4.63l21.52-5.16v-2.92l-21.55 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-3">
          <path
            data-name="Rectangle 193-3"
            fill="#233762"
            d="M72.65 49.1l22.04-5.29v3.57l-22.04 5.33V49.1z"
          />
          <path
            data-name="Path 2349-3"
            d="M94.94 47.65L72.39 53.1v-4.27l22.55-5.4zm-22 4.67l21.52-5.2V44.2l-21.55 5.16z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-3"
          fill="#fff"
          d="M83.11 10.63l1.44-.32v39.52l-1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-4">
        <g data-name="Group 498-4">
          <path
            data-name="Rectangle 182-4"
            fill="#233762"
            d="M127.46 8.27L99.67 2.24v49.49l27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338-4"
            d="M99.18 1.53L128 7.76v51.53l-28.78-7zM127 8.8L100.16 3v48.23L127 57.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-4">
          <path
            data-name="Rectangle 183-4"
            fill="#233762"
            d="M124.45 12.93l-22.04-4.85v3.57l22.04 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-4"
            d="M102.16 7.72l22.55 5V17l-22.55-5zm22 5.49l-21.49-4.74v2.92l21.52 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-4">
          <path
            data-name="Rectangle 184-4"
            fill="#233762"
            d="M124.45 16.54l-22.04-4.89v3.57l22.04 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-4"
            d="M102.16 11.28l22.55 5v4.27l-22.55-5.06zm22 5.54L102.67 12v3l21.52 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-4">
          <path
            data-name="Rectangle 185-4"
            fill="#233762"
            d="M124.45 20.15l-22.04-4.93v3.57l22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-4"
            d="M102.16 14.85l22.55 5v4.27L102.16 19zm22 5.58l-21.49-4.82v2.92l21.52 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-4">
          <path
            data-name="Rectangle 186-4"
            fill="#233762"
            d="M124.45 23.79l-22.04-4.98v3.57l22.04 5.02v-3.61z"
          />
          <path
            data-name="Path 2342-4"
            d="M102.16 18.44l22.55 5.09v4.27l-22.55-5.15zm22 5.63l-21.52-4.87v2.92L124.19 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-4">
          <path
            data-name="Rectangle 187-4"
            fill="#233762"
            d="M124.45 27.4l-22.04-5.02v3.57l22.04 5.06V27.4z"
          />
          <path
            data-name="Path 2343-4"
            d="M102.16 22l22.55 5.13v4.27l-22.55-5.19zm22 5.67l-21.52-4.91v2.92l21.52 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-4">
          <path
            data-name="Rectangle 188-4"
            fill="#233762"
            d="M124.45 31.01l-22.04-5.06v3.56l22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-4"
            d="M102.16 25.57l22.55 5.18V35l-22.55-5.23zm22 5.72l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-4">
          <path
            data-name="Rectangle 189-4"
            fill="#233762"
            d="M124.45 34.62l-22.04-5.11v3.57l22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-4"
            d="M102.16 29.14l22.55 5.23v4.26l-22.55-5.28zm22 5.76l-21.52-5v2.93l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-4">
          <path
            data-name="Rectangle 190-4"
            fill="#233762"
            d="M124.45 38.23l-22.04-5.15v3.57l22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-4"
            d="M102.16 32.71L124.71 38v4.27L102.16 37zm22 5.8l-21.52-5v2.92l21.52 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-4">
          <path
            data-name="Rectangle 191-4"
            fill="#233762"
            d="M124.45 41.85l-22.04-5.2v3.56l22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-4"
            d="M102.16 36.28l22.55 5.31v4.27l-22.55-5.37zm22 5.84L102.67 37v3l21.52 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-4">
          <path
            data-name="Rectangle 192-4"
            fill="#233762"
            d="M124.45 45.48l-22.04-5.24v3.57l22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-4"
            d="M102.16 39.87l22.55 5.36v4.26l-22.55-5.41zm22 5.89l-21.52-5.13v2.92l21.52 5.16z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-4">
          <path
            data-name="Rectangle 193-4"
            fill="#233762"
            d="M124.45 49.1l-22.04-5.29v3.57l22.04 5.33V49.1z"
          />
          <path
            data-name="Path 2349-4"
            d="M102.16 43.43l22.55 5.4v4.27l-22.55-5.45zm22 5.93l-21.52-5.16v2.92l21.52 5.2z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-4"
          fill="#fff"
          d="M113.99 10.63l-1.44-.32v39.52l1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-5">
        <g data-name="Group 498-5">
          <path
            data-name="Rectangle 182-5"
            fill="#233762"
            d="M130.87 8.27l27.79-6.03v49.49l-27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338-5"
            d="M159.15 52.24l-28.78 7V7.76l28.78-6.23zm-27.78 5.54l26.8-6.55V3l-26.8 5.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-5">
          <path
            data-name="Rectangle 183-5"
            fill="#233762"
            d="M133.88 12.93l22.03-4.85v3.57l-22.03 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-5"
            d="M156.17 11.93l-22.55 5v-4.26l22.55-4.95zm-22 4.23l21.52-4.77V8.47l-21.56 4.74z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-5">
          <path
            data-name="Rectangle 184-5"
            fill="#233762"
            d="M133.88 16.54l22.03-4.89v3.57l-22.03 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-5"
            d="M156.17 15.49l-22.55 5.06v-4.27l22.55-5zm-22 4.28L155.66 15v-3l-21.53 4.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-5">
          <path
            data-name="Rectangle 185-5"
            fill="#233762"
            d="M133.88 20.15l22.03-4.93v3.57l-22.03 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-5"
            d="M156.17 19.06l-22.55 5.1v-4.27l22.55-5zm-22 4.33l21.52-4.86v-2.92l-21.53 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-5">
          <path
            data-name="Rectangle 186-5"
            fill="#233762"
            d="M133.88 23.79l22.03-4.98v3.57l-22.03 5.02v-3.61z"
          />
          <path
            data-name="Path 2342-5"
            d="M156.17 22.65l-22.55 5.15v-4.27l22.55-5.09zm-22 4.37l21.52-4.9V19.2l-21.53 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-5">
          <path
            data-name="Rectangle 187-5"
            fill="#233762"
            d="M133.88 27.4l22.03-5.02v3.57l-22.03 5.06V27.4z"
          />
          <path
            data-name="Path 2343-5"
            d="M156.17 26.22l-22.55 5.19v-4.27L156.17 22zm-22 4.41l21.52-4.94v-2.92l-21.53 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-5">
          <path
            data-name="Rectangle 188-5"
            fill="#233762"
            d="M133.88 31.01l22.03-5.06v3.56l-22.03 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-5"
            d="M156.17 29.79L133.62 35v-4.25l22.55-5.18zm-22 4.46l21.52-5v-2.91l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-5">
          <path
            data-name="Rectangle 189-5"
            fill="#233762"
            d="M133.88 34.62l22.03-5.11v3.57l-22.03 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-5"
            d="M156.17 33.35l-22.55 5.28v-4.26l22.55-5.23zm-22 4.51l21.52-5v-3l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-5">
          <path
            data-name="Rectangle 190-5"
            fill="#233762"
            d="M133.88 38.23l22.03-5.15v3.57l-22.03 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-5"
            d="M156.17 36.92l-22.55 5.33V38l22.55-5.27zm-22 4.55l21.52-5.08v-2.92l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-5">
          <path
            data-name="Rectangle 191-5"
            fill="#233762"
            d="M133.88 41.85l22.03-5.2v3.56l-22.03 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-5"
            d="M156.17 40.49l-22.55 5.37v-4.27l22.55-5.31zm-22 4.59L155.66 40v-3l-21.53 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-5">
          <path
            data-name="Rectangle 192-5"
            fill="#233762"
            d="M133.88 45.48l22.03-5.24v3.57l-22.03 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-5"
            d="M156.17 44.08l-22.55 5.41v-4.26l22.55-5.36zm-22 4.63l21.52-5.16v-2.92l-21.53 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-5">
          <path
            data-name="Rectangle 193-5"
            fill="#233762"
            d="M133.88 49.1l22.03-5.29v3.57l-22.03 5.33V49.1z"
          />
          <path
            data-name="Path 2349-5"
            d="M156.17 47.65l-22.55 5.45v-4.27l22.55-5.4zm-22 4.67l21.52-5.2V44.2l-21.53 5.16z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-5"
          fill="#fff"
          d="M144.34 10.63l1.44-.32v39.52l-1.44.35V10.63z"
        />
      </g>
      <path
        fill="#233762"
        d="M36.69 3.36h1.26v45.27h-1.26zM97.92 3.36h1.26v45.27h-1.26z"
      />
    </svg>
  );
};
